import SelectCustom from '2-core-elements/FormElements/SelectCustom';
import { type FC, useId } from 'react';
import { getActiveFilterValueByField, getUpdatedFilters } from './ListingFilterHelpers';
import { type ActiveFilter, type FilterItem } from './ListingFiltersTypes';

// this component the default select behaviour
// get the placeholder and field from filters
// on change set the activeFilters value of the same field

interface ListingFilterSelectProps {
    placeholder: string;
    field: string;
    label?: string;
    activeFilters: ActiveFilter[]; // current filter that is active (selected)
    setActiveFilters: (newFilters: ActiveFilter[]) => void; // function to update active filters
    items: FilterItem[];
    disabled?: boolean;
}

const ListingFilterSelect: FC<ListingFilterSelectProps> = ({
    placeholder,
    field,
    activeFilters,
    setActiveFilters,
    items,
    disabled,
    label,
}) => {
    const baseId = useId();
    const id = `${baseId}-${field}`;
    // set the option for select element (label and value have same value)
    const options = items.map(({ label: optionsLabel, value }) => {
        return { label: optionsLabel, value };
    });

    // find the activeFilter Filters value (string[])
    const activeFilterValue = getActiveFilterValueByField(activeFilters, field);

    // always get [0] since single value
    const selectValue = activeFilterValue[0] && activeFilterValue[0] !== '' ? {
        label: items.find(item => {
            return activeFilterValue[0] === item.value;
        })?.label || activeFilterValue[0], value: activeFilterValue[0],
    } : null;

    return (
        <div className="listing-app-filter-item">
            {label && <label htmlFor={id} className="listing-app-filter-label">{label}</label>}
            <SelectCustom
                id={id}
                placeholder={placeholder}
                options={options}
                value={selectValue}
                disabled={disabled}
                onChange={(optionValue): void => {
                    setActiveFilters(
                        getUpdatedFilters(activeFilters, field, optionValue ? [optionValue.value] : [])
                    );
                }}
            />
        </div>
    );
};

export default ListingFilterSelect;
